<template>
  <div class="avti" id="Advertise">
    <p class="title" name="Advertise">Advertise</p>
    <div class="main">
      <el-row class="point-row" :gutter="20" v-for="(item, index) in points" :key="index">
        <el-col class="avti-text" :span="11" :xs="24" v-if="index % 2 === 0">
          <div>
            <h4 class="sub-title">{{item.title}}</h4>
            <p class="descript avti-descript">{{item.desc}}</p>
          </div>
        </el-col>
        <el-col :span="13" :xs="24" class="avti-img" v-else>
          <img :width="`${item.width}`" :src="require(`@images/avti_${index + 1}.png`)" />
        </el-col>
        <el-col class="avti-text" :span="11" :xs="24" v-if="index % 2 === 1">
          <div>
            <h4 class="sub-title">{{item.title}}</h4>
            <p class="descript avti-descript">{{item.desc}}</p>
          </div>
        </el-col>
        <el-col :span="13" :xs="24" class="avti-img" v-else>
          <img :width="`${item.width}`" :src="require(`@images/avti_${index + 1}.png`)" />
        </el-col>
      </el-row>
      <h4 class="sub-title">We support the below integration for buying into our marketplace:</h4>
      <Integration :items="items" />
    </div>
  </div>
</template>
<script>
import Integration from "./Integration";

export default {
  name: "Advertise",
  components: {
    Integration
  },
  data: function () {
    return {
      points: [
        {
          title: 'High Value Audiences',
          desc: 'Reach high value, influential global mobile users.',
          width: '75%'
        },
        {
          title: 'No Buyer Fee',
          desc: 'As a developer focused platform, we do not charge any buyer fee from our advertisers & demand partners.',
          width: '60%'
        },
        {
          title: 'Premium & Popular APPs',
          desc: 'Access to top quality global mobile inventory to boost your brand awareness & performance opportunities to achieve your campaigns ROI.',
          width: '75%'
        },
        {
          title: 'AI Powered Optimization Algorithm',
          desc: 'Powered by our proprietary AI optimization algorithm, our creative optimization solution help advertisers to optimize creatives that will engage and convert with best performance.',
          width: '75%'
        },
        {
          title: 'Advanced & Contextual Targeting',
          desc: 'Looking for “Whales”? With our advanced targeting and audience’s data powered by our AI technology, we can help you identify the big spenders.',
          width: '75%'
        },
        {
          title: 'Transparent inventory',
          desc: 'Adhering to IAB and industry best practices, our demand partners have full transparency into our inventory.',
          width: '55%'
        },
        {
          title: 'Fraud Free Marketplace',
          desc: 'Working with industry MRC accredited partners together with our proprietary tool, we strive to keep our ad marketplace free from fraudulent bad actors.',
          width: '70%'
        }
      ],
      items: [
        {
          title: 'RTB Integration',
          btText: 'Contact Us',
          img: 'rtb.png'
        },
        {
          title: 'Integrate via API',
          btText: 'Sign Up',
          img: 'api.png'
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.avti {
  position: relative;
  box-shadow: $section-box-shadow;
  padding: 0;
  .main {
    margin-top: px2rem(50);
    max-width: px2rem(1000);
    margin: 0 auto;
    padding-bottom: px2rem(40);
    .point-row {
      // height: px2rem(250);
      margin: px2rem(50) px2rem(80);
      .avti-text{
        height: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
        .sub-title {
          max-width: px2rem(400);
        }
        .avti-descript {
          font-size: px2rem(18);
          letter-spacing: 1px;
          line-height: 1.6em;
          text-align: left;
          width: px2rem(400);
          margin: 0 auto;
          margin-top: px2rem(-5);
        }
      }
      .avti-img {
        // img {
        //   // width: 75%;
        // }
      }
    }
    .sub-title {
      font-size: px2rem(25);
      color: $--color-primary;
      text-align: center;
    }
  }
}
</style>